<template>
  <StoryblokComponent v-for="blokBody in blok.blocks" :key="blokBody._uid" :blok="blokBody" />
  <SiteChildPages v-if="!blok.blocks?.length && story" :story="story" />
</template>
<script setup>
import { storyText, summarize } from '~/composables/useHrMeta'

const { formatBreadcrumbs } = useHrMeta()
const props = defineProps({ blok: Object })
// Without a description in Storyblok, the start of the page's own text
const description = props.blok?.description || summarize(storyText(props.blok?.blocks))
const story = inject('story', computed(() => undefined))
const hero = props.blok.blocks?.find(blok => blok.component === 'SbHero')
let image = null
if (hero) {
  image = hero.background?.find(blok => blok.component === 'SbImage')
}

formatBreadcrumbs()

useHead({
  title: props.blok?.title,
  meta: [
    description ? { key: 'description', name: 'description', content: description } : null,
    props.blok?.title
      ? {
          key: 'og:title',
          property: 'og:title',
          content: `${props.blok?.title} - Hengelose Revue`
        }
      : null,
    description
      ? {
          key: 'og:description',
          property: 'og:description',
          content: description
        }
      : null,

    image
      ? {
          key: 'og:image',
          property: 'og:image',
          content: image.image.filename
        }
      : null
  ]
})
</script>
